import {FilledInputProps, OutlinedInputProps} from "@material-ui/core";
import {FieldProps, FunctionField, InputProps, Record, SelectInput,} from "react-admin";
import {useStore} from "./store";
import {useForm} from "react-final-form";
import {FormApi} from "final-form";

export const EditableSelectField = (
  props: FieldProps & {
    source: string;
    choices: any;
    getInputProps?: (
      record: Record,
      form: FormApi<
        globalThis.Record<string, any>,
        Partial<globalThis.Record<string, any>>
      >
    ) =>
      | Partial<InputProps>
      | Partial<FilledInputProps>
      | Partial<OutlinedInputProps>
      | undefined;
  }
) => {
  const { editable } = useStore();
  const form = useForm();
  const { getInputProps, ...rest } = props;
  return editable ? (
    <FunctionField
      {...rest}
      render={(record: Record | undefined) => (
        <SelectInput
          variant="outlined"
          {...rest}
          onClick={(e) => e.stopPropagation()}
          choices={rest.choices}
          fullWidth
          label=""
          InputProps={
            getInputProps && record ? getInputProps(record, form) : undefined
          }
        />
      )}
    />
  ) : (
    <SelectInput {...rest} variant="outlined" label="" fullWidth disabled />
  );
};
